import React, { useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import HeadingSample from "../components/utility/headingSample";
import AboutUs_panel from "../components/aboutUs/aboutUs_panel";
import Advisors from "../components/aboutUs/advisors";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../components/firebase/firebase"
const AboutUs: React.FC = () => {
    // -------------sec1setting------
    const sec1Subtitle = "What we do?";
    const sec1Title = [
        "ABOUT MINERALEX GROUP ",
        "#F8D835",
    ];
    // ---------sec2setting--------
    const sec2title = {
        text: "",
        color: "#FFFFFF"
    }
    const sec2subtitle = {
        text: "ABOUT MINERALEX GROUP",
        color: "#F8D835",
    }
    const sec2contexts = {
        text: [
            " Mineralex Group specializing in blockchain technology, managing and investing in mineral exploration and mining projects. Mineralex Group poised to leverage over a decade of experience in Sierra Leone's mineral sector through its subsidiary, Mineralex (SL) Limited.",
            "The group's primary objective is to integrate blockchain technology with traditional mining practices, thereby offering global investors accessible, transparent, and flexible investment opportunities in valuable mineral resources.",
            "In response to the escalating global demand for minerals such as gold, coltan, and rare earth metals, Mineralex Group plans to address traditional industry challenges—such as high barriers to entry, unequal profit-sharing mechanisms and lack of transparency—by leveraging blockchain-based tokenization.",
        ],
        color: "#FFFFFF"
    }

    // -----------sec3setting-------
    const sec3image = "/aboutUs/logo_blue.svg";
    const sec3title = {
        text: "",
        color: "#172B6B"
    }
    const sec3subtitle = {
        text: "ABOUT MINERALEX (SL)",
        color: "#3CCDB3",
    }
    const sec3contexts = {
        text: [
            "Mineralex (SL) Limited was founded in 2023 as new mineral exploration and mining company operating in Sierra Leone as part of strategic shift of Mineralex Group from a traditional mining entity to blockchain-based mining and tokenization entity. Mineralex (SL) serves as the successor to Avivit Minerals Company, which had been active in the mineral-rich Sella Limba and Sanda Loko Chiefdoms since 2007.",
            "Mineralex (SL) focuses on high-value mineral deposits, including bedrock Gold, Coltan, Rare Earth Elements (REE), Tin and Diamonds.",
            "Mineralex (SL)'s ownership structure is uniquely designed to align the interests of local communities with the company's growth objectives.",
        ],
        color: "#000000"
    }

    // -------set7setting------
    const sec7name1 = "Sylvester Cyril Sandy";
    const sec7position1 = " Mineralex SL Head Geologist";
    const sec7context1 = "Sylvester Cyril Sandy is an experienced geologist and educator from Sierra Leone with over 40 years in mineral exploration and community development. He holds a B.Sc. in Geology and Chemistry and has led major diamond and gold exploration projects with SLDC, NDMC, Avivit Minerales, AMR Gold and other mining firms. He also played key roles in rural development and vocational training with MAPCO and GTZ-backed programs. His career blends technical expertise, educational leadership, and deep community engagement.";
    const sec7name2 = "Richard Childs";
    const sec7position2 = "Advisor";
    const sec7context2 = "Richard Childs is a Commercial and Contracts Professional with over 20 years of international experience in construction and infrastructure projects. He currently advises on NEOM Oxagon Infrastructure for SYSTRA Arabia, leading commercial strategy and correspondence. Richard has held key roles with Bechtel, NCOC, and CCC, specializing in cost management, procurement, and contract formation. He holds an MSc in International Construction Management and is known for his leadership on complex, high-value projects.";
    const sec7name3 = "Andrey Nikolaev";
    const sec7position3 = "Advisor";
    const sec7context3 = "Andrey Nikolaev is an experienced Geology Technical Supervisor with a diverse background in both the minerals and healthcare industries. Currently at Northern Star Resources, he brings over two decades of leadership in project management, construction, and business strategy. He previously served as a long-term Project Manager at International SOS, where he led initiatives in healthcare consulting and operations. Andrey holds a Bachelor of Architecture from Far Eastern Polytechnical University and is skilled in capital projects, safety, and multidisciplinary team coordination.";
    // Refs for in-view detection
    const sec2Ref = useRef(null);
    const Ref = useRef(null);
    // In-view hooks
    const sec2InView = useInView(sec2Ref, { once: false, amount: 0.2 });
    const InView = useInView(Ref, { once: false, amount: 0.2 });
    const [scrollDir, setScrollDir] = useState("down");
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    useEffect(() => {
        let lastScrollY = window.scrollY;

        const updateScrollDirection = () => {
            const scrollY = window.scrollY;
            setScrollDir(scrollY > lastScrollY ? "down" : "up");
            lastScrollY = scrollY;
        };

        window.addEventListener("scroll", updateScrollDirection);
        return () => window.removeEventListener("scroll", updateScrollDirection);
    }, []);
    // Animation variants
    const itemVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 2, type: "spring", bounce: 0.2 },
        },
    };

    const [galleryImages, setGalleryImages] = useState<any[]>([]);

    useEffect(() => {
        const fetchImages = async () => {
            const q = query(collection(db, "gallery"), orderBy("createdAt", "desc"));
            const snapshot = await getDocs(q);
            const images = snapshot.docs.map((doc) => {
                const data = doc.data();
                return {
                    id: doc.id,
                    imageUrl: data.imageUrl,
                    createdAt: data.createdAt?.toDate().toLocaleString() || "Unknown",
                };
            });
            setGalleryImages(images);
        };

        fetchImages();
    }, []);

    return (

        <div className="w-full  flex flex-col items-center justify-center bg-white box-border overflow-hidden ">
            {/* ------------section1----------- */}
            <div id="aboutUs" className="h-[700px] w-[100vw]  bg-[url('../public/aboutUs/section1.svg')] inset-0 lg:pl-24 bg-black/30  bg-blend-overlay  bg-cover bg-center ">
                <HeadingSample subtitle={sec1Subtitle} title={sec1Title} />
            </div>
            {/* -----------section2-------- */}
            <div id="mineralexGroup" className="w-full flex flex-col justify-center items-center bg-[#172B6B] gap-4">
                <div className="w-full flex flex-col justify-center  2xl:flex-row  lg:justify-around items-center gap-6 sm:gap-12 p-4 lg:p-10">
                    <div className="w-full ">
                        <AboutUs_panel title={sec2title} subtitle={sec2subtitle} contexts={sec2contexts} />
                    </div>
                    <motion.div
                        ref={sec2Ref}
                        initial="hidden"
                        animate={sec2InView ? "hidden" : "visible"}
                        variants={itemVariants}
                        className="w-full  max-w-xl  h-auto flex-shrink-0 "
                    >
                        <img src="/aboutUs/section2_balance.svg" alt="balance" className="w-full h-auto" />
                    </motion.div>

                </div>

                <div className="w-full flex flex-col justify-center items-center gap-6 sm:gap-12 p-4">
                    <div className="font-normal text-[#FFFFFF] font-bungeeinline text-center text-3xl sm:text-[42px] uppercase ">
                        FOUNDERS
                    </div>

                    <div className="contain w-full flex flex-col md:flex-row justify-around items-start gap-6">
                        <Advisors
                            image="/aboutUs/alex.svg"
                            name="ALEXANDER DASHEVSKI"
                            position="Co-Founder, Mineralex Group"
                            context=
                            "Aleksandr Dashevsky is a global entrepreneur and visionary leader with over 30 years of experience in energy, infrastructure, and international consulting. As co-founder of Mineralex Group, he pioneers the fusion of traditional mineral asset management with blockchain technology, aiming to democratize access to gold and precious mineral investments. Recognized by Forbes Global, Aleksandr has led high-impact projects for industry giants like Shell and Exxon, and brings a unique blend of strategic acumen, international insight, and innovation to the evolving landscape of tokenized finance."

                        />
                        <Advisors
                            image="/aboutUs/shraga.svg"
                            name="SHRAGA ISRAEL"
                            position="Co-Founder, Mineralex Group"
                            context=
                            "M.Sc. in Finance and entrepreneur with 20+ years of experience leading large-scale geological research projects. Successfully managed mineral exploration initiatives and complex infrastructure programs across Africa. Also led major agriculture and water projects focused on sustainability and regional development. Deeply engaged in West Africa, with a strong emphasis on community support and local partnerships. Combines financial expertise with hands-on leadership in remote and emerging markets. Committed to creating long-term value through responsible and impactful project development."
                        />
                    </div>
                </div>
            </div>


            {/* -------------section3------------ */}

            <div id="mineralex(sl)" className="w-full flex flex-col justify-center items-center bg-white gap-4 py-4 sm:py-12">
                <div className="w-full flex flex-col  lg:flex-row justify-around items-center gap-10 sm:gap-[26px] p-6 lg:p-10">
                    <div className="w-full max-w-4xl flex flex-col justify-center items-center gap-10">
                        <AboutUs_panel image={sec3image} title={sec3title} subtitle={sec3subtitle} contexts={sec3contexts} />
                        <img src="/aboutUs/sec3_profit.png" alt="sec3_profit" className="w-full max-w-xl h-auto" />
                        {/* <div className="w-full flex flex-col sm:flex-row justify-start items-center sm:items-start gap-4">
                            <ProfitDisplay value="10%" explanation="Sella Limba Chiefdom" />
                            <ProfitDisplay value="10%" explanation="Sanda Loko Chiefdom" />
                            <ProfitDisplay value="80%" explanation="Mineralex Group" />
                        </div> */}
                    </div>

                    <motion.div
                        ref={Ref}
                        initial="visible"
                        animate={InView && scrollDir === "down" ? "visible" : "visible"}
                        variants={{
                            hidden: { opacity: 0, x: 400, transition: { duration: 1 } },
                            visible: { opacity: 1, x: 0, transition: { duration: 2, type: "spring", stiffness: 100, damping: 20 } },
                        }}
                        className="w-full max-w-[545px]"
                    >
                        <img src="/aboutUs/map.svg" alt="map" className="w-full h-full" />
                    </motion.div>
                </div>

                <div className="w-full h-full  grid grid-cols-1 lg:grid-cols-2 items-center gap-4">
                    <div
                        id="history"
                        className="w-full flex flex-col justify-center items-center gap-6 p-4">

                        <div className="font-bold text-[#3CCDB3] font-bungeeinline  text-3xl sm:text-[42px] uppercase ">
                            History
                        </div>
                        <div className="font-bold text-black font-montserrat  text-2xl sm:text-3xl pt-4">
                            Timeline of Key Events
                        </div>
                        <motion.div
                            ref={sec2Ref}
                            initial="hidden"
                            animate={sec2InView ? "visible" : "visible"}
                            variants={itemVariants}
                            className="w-full h-auto"
                            onClick={() => setSelectedImage("/aboutUs/sec3_history.png")}
                        >
                            <img src="/aboutUs/sec3_history.png" alt="sec3_history" className="w-full h-auto max-w-3xl mx-auto" />
                        </motion.div>
                    </div>

                    <div className="w-full h-full  flex flex-col justify-center items-center gap-6 p-4">
                        <div className="font-bold text-black font-montserrat  text-2xl sm:text-3xl pt-4">
                            Gallery
                        </div>
                        <div className="w-full h-full max-h-[60vh] grid grid-cols-2 md:grid-cols-4 gap-4 border-2 border-black rounded-lg overflow-y-auto p-6">
                            {galleryImages.map((img, index) => (
                                img.imageUrl ? (
                                    <div key={img.id || index} className="flex flex-col items-center">
                                        <img
                                            src={img.imageUrl}
                                            alt={`Gallery ${index}`}
                                            className="w-full h-auto rounded-md object-cover cursor-pointer hover:scale-105 transition-transform duration-300"
                                        />
                                        <p className="text-sm text-gray-600 mt-1">{img.createdAt}</p>
                                    </div>
                                ) : null
                            ))}
                        </div>
                    </div>

                    {/* Modal */}
                    {selectedImage && (
                        <div
                            className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
                            onClick={() => setSelectedImage(null)}
                        >
                            <img
                                src={selectedImage}
                                alt="Full View"
                                className="max-w-4xl max-h-[90vh] rounded-lg shadow-lg"
                                onClick={(e) => e.stopPropagation()} // prevent closing when clicking image
                            />
                            <button
                                className="absolute top-4 right-4 text-white text-3xl font-bold"
                                onClick={() => setSelectedImage(null)}
                            >
                                &times;
                            </button>
                        </div>
                    )}

                </div>

            </div>

            <div
                id="staffAndPolicies"
                className="w-full flex flex-col justify-center items-center py-10">
                <div className="font-bold text-[#3CCDB3] font-bungeeinline  text-2xl sm:text-3xl pb-8 uppercase ">
                    STAFF and Policies
                </div>
                <div className="w-full h-full hidden md:block">
                    <img src="/aboutUs/sec6bg.png" alt="sec6_bg" className="w-full h-auto" />
                </div>

                <motion.div
                    ref={sec2Ref}
                    initial="hidden"
                    animate={sec2InView ? "visible" : "hidden"}
                    variants={itemVariants}
                    className="w-[90%] h-full flex flex-col md:flex-row justify-around items-start gap-6 md:gap-0 p-4 sm:p-10 -mt-5 lg:-mt-10 z-10  bg-white  rounded-2xl shadow-2xl ">
                    <div className="contain h-full flex flex-col justify-start items-center md:items-start gap-6 font-montserrat font-light text-center md:text-left sm:p-10">
                        <div className="font-bold text-2xl sm:text-3xl text-[#3CCDB3] font-bungeeinline">
                            STAFF
                        </div>
                        <div className="text-lg sm:text-xl">
                            Mineralex focuses on building local capacity in Sierra Leone through merit-based hiring and comprehensive training programs. The company offers competitive salaries and emphasizes developing local talent to reduce expatriate dependency, while ensuring compliance with international standards.
                        </div>
                    </div>

                    <div className="contain h-full flex flex-col justify-start items-center md:items-start gap-6 font-montserrat font-light text-center md:text-left sm:p-10">
                        <div className="font-bold text-2xl sm:text-3xl text-[#3CCDB3] font-bungeeinline">
                            POLICIES
                        </div>
                        <div className="text-lg sm:text-xl">
                            The Mineralex Group is deeply committed to maintaining its integrity by adopting policies which aligns with global anti-corruption standards, including the U.S. Foreign Corrupt Practices Act and Canada’s Corruption of Foreign Public Officials Act.
                            <br />
                            <br />
                            Mineralex policies includes Anti-Corruption, Anti-Bribery, and Anti-Fraud Policy, Code of Business Conduct and Ethics, Environmental Policy, Health and Safety Policy.
                        </div>
                    </div>
                </motion.div>


            </div>
            {/* -----------section6---- */}
            <div id="mainTeam" className="w-full flex flex-col justify-center items-center bg-[#F9A235] gap-6 p-4">
                <div className="w-full flex flex-col justify-center items-center gap-2">
                    <div className="font-bold text-[#FFFFFF] font-bungeeinline  text-3xl sm:text-[42px] uppercase ">
                        Meet OUR TEAM AND ADVISORS
                    </div>
                </div>

                <div className=" w-full flex flex-col lg:flex-row justify-around gap-6">
                    <Advisors image={"/aboutUs/sec6_Sylvester_Cyril_Sandy.png"} name={sec7name1} position={sec7position1} context={sec7context1} />
                    <Advisors image={"/aboutUs/sec6_Richard_Childs.png"} name={sec7name2} position={sec7position2} context={sec7context2} />
                    <Advisors image={"/aboutUs/sec6_Andrey_Nikolaev.png"} name={sec7name3} position={sec7position3} context={sec7context3} />
                </div>
            </div>


        </div >

    );
};

export default AboutUs;